/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {VehicleFinancialCompanyVo} from "./vehicle-financial-company-vo.model";

export class VehicleFinancialDto extends JSONable {
  uuid: string | undefined
  companyOwner: VehicleFinancialCompanyVo | undefined // dropdown
  operator: VehicleFinancialCompanyVo | undefined // dropdown
  taxCategory: string | undefined // dropdown
  fuelCards: string | undefined
  valVehicle: number | undefined
  valResidual: number | undefined
  valOperations: number | undefined
  valAccesories: number | undefined
  costKm: number | undefined
  costKmNotDriven: number | undefined
  financingType: string | undefined
  financingPeriod: number | undefined
  nrCtr: number | undefined
  nrKmCtr: number | undefined
  kmAtRendition: number | undefined
  casco: string | undefined
  startDate: string | undefined
  endDate: string | undefined
  deliveryDate: string | undefined
  returnDate: string | undefined
  nrInventory: number | undefined
  insurance: string | undefined
  policyNr: number | undefined
  insuranceStartDate: string | undefined
  insuranceEndDate: string | undefined
  monitoringStartDate: string | undefined
}
